/*+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'react',
	'mobx-react',
	'@ba/ba-ui-carbon',
	'prop-types'
], function (
	React,
	MobxReact,
	BA_UI_CARBON,
	PropTypes
) {

	/**
	 * @example
	 * Below is a sample ComboBox properties payload
	 * {
	 * 	item :
	 * 	 {
				id: 'testComboBox',
				editor: {
					uiControl: {
						type: 'ComboBox',
						placeholder: 'Select an item placeholder',
						items: [
							{ value: 1, label: '1' },
							{ value: 2, label: '2' }
						],
						disabled: false,
						onChange: ()=>{}
					}
				}
			}
		}
	**/
	class ComboBox extends React.Component {

		render() {
			//TODO: Handle setPropertyValue and Value, currently, it handles PropertyLayoutList input only
			const { item, className } = this.props;
			const uiControl = this._getUIControl(item);
			const SIZE = 'lg';
			const {
				items,
				placeholder,
				shouldFilterItem,
				disabled,
				onChange
			} = uiControl;

			const containerProps = {
				className,
				'data-property-id': item.id
			};

			return (
				<div {...containerProps}>
					<BA_UI_CARBON.ComboBox
						id={item.id}
						items={items || []}
						placeholder={placeholder}
						shouldFilterItem={shouldFilterItem || this._shouldFilterItem}
						itemToString={(entry) => (entry ? entry.label : '')}
						disabled={disabled}
						onChange={onChange}
						size={SIZE}
						light
					/>
				</div>
			);
		}

		_getUIControl(item) {
			return item && item.editor && item.editor.uiControl && item.editor.uiControl || {};
		}

		_shouldFilterItem(entry) {
			const text = entry && entry.item.label;
			const inputValue = entry && entry.inputValue;
			return text && inputValue ? text.toLowerCase().startsWith(inputValue.toLowerCase()) : true;
		}

	}

	ComboBox.propTypes = {
		item: PropTypes.shape({
			editor: PropTypes.shape({
				uiControl: PropTypes.shape({
					id: PropTypes.string,
					placeHolder: PropTypes.string,
					disabled: PropTypes.bool,
					items: PropTypes.arrayOf(PropTypes.object),
					onChange: PropTypes.func,
					shouldFilterItem: PropTypes.func
				})
			}),
			id: PropTypes.string.isRequired
		}),
		className: PropTypes.string
	};
	ComboBox.defaultProps = {};
	return MobxReact.observer(ComboBox);
});
